import { cn } from '../../utils/cn.js';

export default function FormFooter({ children, className = '' }) {
  return (
    <div className={cn('flex flex-row flex-wrap justify-end gap-4 py-10 md:pb-0', className)}>
      {children}
    </div>
  );
}
